import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class RequestStatusService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<RequestStatus[]> => {
    return this.apiHttp.get<RequestStatus[]>("requeststatuses");
  };

  public get = (id: number): Observable<RequestStatus> => {
    return this.apiHttp.get<RequestStatus>(`requeststatuses/${id}`);
  };
}

export interface RequestStatus {
  id: number;
  name: string;
  order: number;
}

export enum RequestStatusEnum {
  Cancelled = -999,
  ExperimentCreationError = -1,
  None = 0,
  Draft = 1,
  Submitted = 2,
  Assigned = 3,
  ReadyForReview = 4,
  Reviewed = 5,
  CreatingExperiment = 6,
  ExperimentInProgress = 7,
  ExperimentCompleted = 8,
  Pollination = 9,
  Harvest = 10,
  PlantedInFlat = 11
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/request-status.service.ts